export default {
  init() {
    // JavaScript to be fired on all pages
    $('.carousel').carousel('pause');

    $(function () {
      $('.plus-minus-toggle').on('click', function () {
        $(this).toggleClass('collapsed hover');
      });
    });

    $('.grid').masonry({
      // set itemSelector so .grid-sizer is not used in layout
      itemSelector: '.grid-item',
      // use element for option
      columnWidth: '.grid-sizer',
      percentPosition: true,
    })

    $('.hamburger').click(function () {
      $(this).toggleClass('is-active');
      $('.nav-menu').fadeToggle(200);
      $('.nav-menu').toggleClass('show');
    });
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.flexslider').flexslider({
      animation: 'slide',
      controlNav: 'thumbnails',
      animationLoop: false,
    });

    $('.flex-direction-nav').appendTo('.flex-viewport');

    if ($('ul.slides li.flex-active-slide').length == 1) {
      $('ul.flex-direction-nav li').addClass('icon-button line-arrow');
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js